import { useTranslation } from "react-i18next";

import availableLanguages from "@/i18n/availableLanguages";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils.ts";

interface props {
  containerClassName?: string;
  imgClassName?: string;
  btnClassName?: string;
  align?: "start" | "center" | "end";
  side?: "left" | "top" | "right" | "bottom";
}

const LanguageSwitcher = ({
  containerClassName,
  imgClassName,
  btnClassName,
  align,
  side,
}: props) => {
  const { i18n } = useTranslation();

  const currentLanguageData =
    availableLanguages.find((item) => item.language === i18n.language) || availableLanguages[0];

  return (
    <div className={containerClassName}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button className={cn("h-12 w-12 p-2", btnClassName)} type="button" variant="outline">
            <img
              alt={currentLanguageData.name}
              className={cn("h-full w-full rounded object-cover", imgClassName)}
              src={currentLanguageData.flagImg}
            />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align={align} className={"z-[1505]"} side={side}>
          {availableLanguages.map(({ language, name, flagImg }) => (
            <DropdownMenuItem
              key={language}
              onClick={() => {
                i18n.changeLanguage(language);
              }}
            >
              <img alt={name} className="h-5 w-6 rounded object-cover" src={flagImg} />
              <span>{name}</span>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default LanguageSwitcher;
